/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, message } from "antd";
import { Collapse, Form, Flex, Row, Col, Space, Select } from "antd";
import { Input, Button, Table, Typography, Badge } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from '../../../hooks/useAccessPageState';
import PackagingService from "../../../service/ERP/Packaging.service";
import OptionService from "../../../service/ERP/Options.service";
import "./MyPage.css";
import { delay } from "../../../utils/util";

const pkService = PackagingService();
const opService = OptionService();

/* ค่าเริ่มต้นแสดงเฉพาะที่เปิดใช้งาน — ที่ปิดแล้วต้องเลือกเองถึงจะเห็น */
const STATUS_OPTIONS = [
  { value: "เปิดการใช้งาน", label: <Badge status="success" text="เปิดการใช้งาน" /> },
  { value: "ปิดการใช้งาน", label: <Badge status="error" text="ปิดการใช้งาน" /> },
  { value: "ทั้งหมด", label: <Badge status="default" text="ทั้งหมด" /> },
];
const DEFAULT_STATUS = "เปิดการใช้งาน";

const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const PackagingAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const [packageTypeOption, setPackageTypeOption] = useState([]);

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      pkService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", DEFAULT_STATUS);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: DEFAULT_STATUS }, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "Create Packaging",
          action: "create",
        },
      },
    });
  };

  const handleEdit = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Packaging",
          action: "edit",
          code: data?.id,
        },
      },
    });
  };

  /* โหมดดูอย่างเดียว — เปิดหน้าเดียวกับแก้ไขแต่ปิดการแก้ไขทั้งฟอร์ม */
  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View Packaging",
          action: "view",
          code: data?.id,
        },
      },
    });
  };

  const handleDelete = (data) => {
    // startLoading();
    // ctmService.deleted(data?.dncode).then( _ => {
    //     const tmp = accessData.filter( d => d.dncode !== data?.dncode );
    //     setAccessData([...tmp]);
    // })
    // .catch(err => {
    //     console.log(err);
    //     message.error("Request error!");
    // });
  };

  const init = async () => {
    const [packagingRes] = await Promise.all([
      opService.optionsPackaging({ p: "type" }),
    ]);
    const { data: pktype } = packagingRes.data;
    // const opn_pktype = pktype.map( v => ({value:v.id, label:v.pktype}));
    setPackageTypeOption(pktype);

    const restored = restoreState();

    /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดการใช้งาน" */
    const values = restored?.searchValues ?? {};
    if (!values.active_status) values.active_status = DEFAULT_STATUS;
    form.setFieldsValue(values);

    handleSearch(values, restored?.tablePagination);
  };

  useEffect(() => {
    init();

    return async () => {
      await delay(400);
      // console.clear();
    };
  }, []);

  const getData = (data) => {
    pkService
      .search(data)
      .then((res) => {
        const { data } = res.data;

        setAccessData(data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Request error!");
      });
  };
  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
            <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item
                      label="Package Code."
                      name="pk_code"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Package Code." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item
                      label="Package Name."
                      name="pk_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Package Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="Package Type." name="pktype_id">
                      <Select
                        // mode='multiple'
                        onChange={handleSearch}
                        allowClear
                        autoClearSearchValue={false}
                        style={{
                          width: "100%",
                          height: "40px",
                        }}
                        placeholder="Please select"
                        maxTagCount="responsive"
                        options={packageTypeOption.map((item) => ({
                          value: item.pktype_id,
                          label: item.pktype_name,
                        }))}
                        getPopupContainer={() =>
                          document.getElementById("area")
                        }
                      ></Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item
                      label="Packaging Name (English)"
                      name="pk_nameEN"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter Packaging Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="Express Name" name="express_name" onChange={handleSearch}>
                      <Input placeholder="Enter Express Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="ชื่อที่ใช้สั่งซื้อ" name="purchase_name" onChange={handleSearch}>
                      <Input placeholder="Enter Purchase Name." />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                    <Form.Item label="สถานะการใช้งาน" name="active_status">
                      <Select
                        style={{ width: "100%", height: "40px" }}
                        options={STATUS_OPTIONS}
                        placeholder="เลือกสถานะ"
                        onChange={handleSearch}
                        getPopupContainer={() => document.getElementById("area")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      {/* <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button> */}
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const allColumns = accessColumn({ handleEdit, handleDelete, handleView });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "packaging_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
          List of Packaging
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create Packaging
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="packaging-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
          {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="id"
                columns={column}
                dataSource={accessData}
                scroll={{ x: 'max-content' }} 
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default PackagingAccess;
